<template>
  <span>{{ formatted }}</span>
</template>

<script>
import dayjs from 'dayjs'

import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

import timezone from 'dayjs/plugin/timezone.js'
dayjs.extend(timezone)

export default {
  props: {
    /**
     * Default date string value. If blank it will use current time.
     */
    value: {
      type: String,
      default: () => new Date().toString()
    },
    /**
     * How to format returned date string: 'sm', 'md', 'lg', 'xl', or custom.
     */
    format: {
      type: String,
      default: 'sm'
    },
    /**
     * Source timezone if you need to convert from something other than a UTC date string.
     */
    src_tz: {
      type: String,
      default: 'UTC'
    },
    /**
     * Return the format as relative string.
     */
    relative: {
      type: Boolean,
      default: false
    },
    /**
     * Include time in the date string.
     */
    time: {
      type: Boolean,
      default: false
    },
    /**
     * Convert to local time.
     */
    convert: {
      type: Boolean,
      default: true
    }
  },
  methods: {},
  computed: {
    formatted() {
      if (!this.value) return ''
      // Remove the decimal points if passed (dayjs doesn't like it)
      const value = this.value.split('.')[0]

      let year = dayjs(value).$y
      let _ts = year > 1900 ? value : new Date().toString()

      if (this.relative) {
        if (this.convert) {
          return dayjs.tz(_ts, this.src_tz).local().fromNow()
        } else {
          return dayjs.tz(_ts, this.src_tz).fromNow()
        }
      } else {
        if (this.convert) {
          return dayjs.tz(_ts, this.src_tz).local().format(this._format)
        } else {
          return dayjs.tz(_ts, this.src_tz).format(this._format)
        }
      }
    },
    _format() {
      switch (this.format) {
        case 'xl':
          return this.time ? 'dddd, MMMM D, YYYY h:mm A' : 'dddd, MMMM D, YYYY'

        case 'lg':
          return this.time ? 'ddd, MMM D, YYYY h:mm A' : 'ddd, MMM D, YYYY'

        case 'md':
          return this.time ? 'MMM D, YYYY h:mm A' : 'MMM D, YYYY'

        case 'sm':
          return this.time ? 'M/D/YYYY h:mm A' : 'M/D/YYYY'

        default:
          return this.format
      }
    }
  }
}
</script>

<style></style>
